import { Component, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../features/auth/auth.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.scss'],
})
export class Navbar {
  username = signal(localStorage.getItem('user_name') || localStorage.getItem('user_full_name') || '');
  pageTitle = signal('Dashboard');

  constructor(private auth: AuthService, private router: Router) {
    this.pageTitle.set(this.getPageTitle(this.router.url));
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.pageTitle.set(this.getPageTitle(this.router.url));
    });
  }

  logout() {
    this.auth.logout().subscribe({
      complete: () => this.router.navigate(['/login']),
      error: () => this.router.navigate(['/login']),
    });
    this.username.set('');
  }

  goToProfile() {
    this.router.navigate(['/perfil/datos-personales']);
  }

  goToNotifications() {
    this.router.navigate(['/notificaciones']);
  }

  avatarLabel() {
    const name = this.username().trim();
    if (!name) return '?';
    const words = name.split(/\s+/).filter(Boolean);
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  }

  private getPageTitle(url: string) {
    if (url.startsWith('/perfil/restablecer-clave')) return 'Restablecer clave';
    if (url.startsWith('/perfil')) return 'Perfil';
    if (url.startsWith('/clientes')) return 'Clientes';
    if (url.startsWith('/permisos')) return 'Permisos de clientes';
    if (url.startsWith('/oposiciones')) return 'Oposiciones';
    if (url.startsWith('/metricas')) return 'Métricas y uso';
    if (url.startsWith('/auditoria')) return 'Auditoría';
    if (url.startsWith('/usuarios')) return 'Usuarios y roles';
    if (url.startsWith('/credenciales')) return 'Credenciales de API';
    if (url.startsWith('/Conexiones-HPIH')) return 'Conexiones HPIH';
    if (url.startsWith('/notificaciones')) return 'Notificaciones';
    return 'Dashboard';
  }
}
